import { render, staticRenderFns } from "./orgOperation.vue?vue&type=template&id=b2067c6c&scoped=true"
import script from "./orgOperation.vue?vue&type=script&lang=js"
export * from "./orgOperation.vue?vue&type=script&lang=js"
import style0 from "./orgOperation.vue?vue&type=style&index=0&id=b2067c6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2067c6c",
  null
  
)

export default component.exports